import { Component, EventEmitter, Input, Output, ChangeDetectorRef, OnInit } from '@angular/core';

@Component({
    selector: 'app-text-editor',
    templateUrl: './text-editor.component.html',
    styleUrls: ['./text-editor.component.css'],
    standalone: false
})
export class TextEditorComponent implements OnInit {
    //-------------------------------------------------------------------------
    public readonly textEditorModules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'link'],
            [{ list: 'ordered' }, { list: 'bullet' }]
        ]
    };

    public readonly allowedFormats = ['bold', 'italic', 'underline', 'link', 'list'];
    //-------------------------------------------------------------------------
    public readonly textEditorStyle = {
        height: 'auto',
        'font-family': "'Roboto', sans-serif",
    };
    //-------------------------------------------------------------------------
    public placeholder = 'Hier Beschreibung einfügen';
    private editorTextInternal: string = '';
    public textLengthBelowMax: boolean = true;
    public readonly maxTextLength = 1000;
    public pureTextLength: number = 0;
    //-------------------------------------------------------------------------

    @Input()
    placeholderText: string | null = null;

    @Input()
    set editorText(val: string | null | undefined) {
        this.editorTextInternal = val ?? '';
    }

    get editorText(): string {
        return this.editorTextInternal;
    }

    //-------------------------------------------------------------------------

    @Output()
    editorTextChange = new EventEmitter<string>();
    @Output()
    textValidityChange = new EventEmitter<boolean>();

    constructor(private cdr: ChangeDetectorRef) {}
    
    ngOnInit() {
        if (this.placeholderText) {
            this.placeholder = this.placeholderText;
        }
    }

    onEditorCreated(editor: any) {
        if (!editor?.root?.innerText) return;
        const innerText = editor.root.innerText;
        if (innerText) this.onTextChange(innerText);
    }

    onEditorChanged(event: any) {
        if (!event?.editor?.root) {
            console.warn('Editor event invalid');
            return;
        }
        const text = event.editor.root.innerText;
        this.onTextChange(text);
        this.editorTextChange.emit(event.editor.root.innerHTML);
    }

    onTextChange(newText: string) {
        const cleanText = this.cleanQuillText(newText);
        const cleanTextLength = cleanText.length;

        const textLengthBelowMax = cleanTextLength <= this.maxTextLength;

        if (this.textLengthBelowMax !== textLengthBelowMax) {
            this.textLengthBelowMax = textLengthBelowMax;
            this.textValidityChange.emit(this.textLengthBelowMax);
        }

        this.pureTextLength = cleanTextLength;
        this.cdr.detectChanges();
    }

    private cleanQuillText(text: string): string {
        if (!text) return '';

        return text
            .replace(/^\n+/, '')     // Entferne Newlines am Anfang
            .replace(/\n+$/, '')     // Entferne Newlines am Ende
            .replace(/^\s+/, '')     // Entferne Leerzeichen am Anfang
            .replace(/\s+$/, '');    // Entferne Leerzeichen am Ende
    }
}
